import { useEffect, useState } from 'react';
import { getReviewData } from 'api/ppaOnboarding';
import { message } from 'antd';
import { IproviderAvailabilityList, IproviderOverrideList } from 'types/appointmentSetting';
import { IBasicInfoStep } from 'types/newUniprofile';
import { FormIdentify } from 'types/form';
import { License, TKlarityServiceServerTableItem, IPaymentInfo } from 'types/common';
import { ReminderSettings } from 'types/calendarSetting';

export interface IReviewData {
    availability: IproviderAvailabilityList | null;
    basicInfo: IBasicInfoStep | null;
    identification: FormIdentify | null;
    licenses: License[] | null;
    override: IproviderOverrideList[] | null;
    calendarSetting: ReminderSettings | null;
    paymentInfo: IPaymentInfo | null,
    services: TKlarityServiceServerTableItem[] | null,
    disqualifyReason: string | null;
}

const usePPAOnboardingReviewInfo = (): [IReviewData, boolean, () => Promise<void>] => {
    const [loading, setLoading] = useState(false);
    const [reviewData, setReviewData] = useState<IReviewData>({
        availability: null,
        basicInfo: null,
        identification: null,
        licenses: null,
        override: null,
        calendarSetting: null,
        paymentInfo: null,
        services: null,
        disqualifyReason: null,
    });

    const loadReviewData = async () => {
        try {
            setLoading(true);
            const res = await getReviewData();
            if (res.data.code === 200) {
                setReviewData(res.data.data);
            } else {
                message.error(res.data.message);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadReviewData();
    }, []);

    return [reviewData, loading, loadReviewData];
};

export default usePPAOnboardingReviewInfo;
